import { FC, SVGProps } from "react";

export type Glyph = FC<SVGProps<SVGSVGElement>>;

const languageCodes = <const>["en-US", "en-UK", "it-IT", "de-DE"];
export type LanguageCode = (typeof languageCodes)[number];

export const isLanguageCode = (value: string): value is LanguageCode => languageCodes.includes(value as LanguageCode);

export type FetcherOptions = {
  url: string;
  signal?: AbortSignal;
  headers?: HeadersInit;
};

export interface FilterParam {
  fieldname: string;
  values?: Exclude<MenuOptionValue, Lookup>[];
  // operator?: "IS_NULL" | "IS_NOT_NULL";
}

export const isLookup = (value: MenuOptionValue): value is Lookup => {
  return !!value && !!(value as Lookup).id && !!(value as Lookup).value;
};

export type Lookup = {
  id: string;
  value: string;
};

export type ListFilters = {
  page: number;
  limit: number;
  q?: string;
  orderBy?: string;
  desc: boolean;
  filters?: FilterParam[];
};

export type Paginated<P> = {
  items: P[];
  total: number;
};

export type PaginationQuery = Partial<ListFilters>;

export type PaginationQueryWithFields<T> = PaginationQuery & { fields: Array<DotNestedKeys<T>> };

export type MenuOptionValue = Lookup | string | number | boolean | null;

/* --- utility types to produce dot-path keys --- */

// Helper: treat plain object-like types (not arrays/functions) as "expandable"
type IsPlainObject<T> = T extends Function ? false : T extends any[] ? false : T extends object ? true : false;

// Recursive builder: for each string key K of T, include K and, if the value is a plain object,
// include `K.${nested}` for every nested key.
type DotNestedKeys<T> = T extends object
  ? {
      [K in Extract<keyof T, string>]: IsPlainObject<T[K]> extends true
        ? K | `${K}.${DotNestedKeys<T[K]>}` // include nested dot-paths
        : K; // leaf key
    }[Extract<keyof T, string>]
  : never;
